import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { gaugeDefaults, mergeWithDefaults, threeColumnMaxWidth, twoColumnMaxWidth } from '../utils/chartDefaults';
import { GaugeChartProps } from '../types/chartProps';
import { applyGaugeChartOptions } from '../utils/gaugeChartUtils';

export const GaugeChart = React.memo(
  React.forwardRef<HighchartsReact.RefObject, GaugeChartProps>((props, ref) => {
    const options: Highcharts.Options = applyGaugeChartOptions(
      mergeWithDefaults({
        chart: {
          type: 'gauge',
          plotBorderWidth: 0,
          plotShadow: false,
          spacingTop: 10,
          spacingBottom: 20
        },
        pane: {
          startAngle: -90,
          endAngle: 89.9,
          background: undefined,
          center: ['50%', '75%'],
          size: '110%'
        },
        yAxis: {
          tickPixelInterval: 90,
          tickPosition: 'inside',
          tickColor: Highcharts.defaultOptions.chart?.backgroundColor || '#FFFFFF',
          tickLength: gaugeDefaults.thickness.default,
          tickWidth: 2,
          minorTicks: false,
          labels: {
            distance: 30
          },
          lineWidth: 0
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: threeColumnMaxWidth
              },
              chartOptions: {
                pane: {
                  size: '80%',
                  center: ['50%', '60%']
                },
                yAxis: {
                  labels: {
                    style: {
                      fontSize: '0.75rem'
                    }
                  }
                }
              }
            },
            {
              condition: {
                maxWidth: twoColumnMaxWidth
              },
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'left',
                  verticalAlign: 'bottom',
                  maxHeight: 64
                }
              }
            }
          ]
        }
      }),
      { ...props, kind: 'gauge' }
    );

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  })
);
